import { RightArrow, RightViewArrow } from '@/components/Icons'
import React from 'react'


interface BreadCrumbProps {
    steps: { label: string, link?: string }[]
    currentStep: string
    className?: string
}
const BreadCrumb = (props: BreadCrumbProps) => {
    const { steps, currentStep } = props
    return (
        <div className='flex flex-row gap-2 justify-center items-center p-8'>
            {steps.map((step: any, index) => (
                <div key={index} className='flex flex-row items-center'>
                    <p className={`font-Gordita-Medium md:text-[20px] text-[14px] cursor-pointer hover:opacity-80 ${step.label === currentStep ? 'text-[#5297FF]' : ''}`}>
                        {step.link ? <a href={step.link}>{step.label}</a> : step.label}
                    </p>
                    {index < steps.length - 1 && <RightViewArrow />}  
                </div>
            ))}
        </div>
    )
}

export default BreadCrumb